import App from "./App.vue";
import { createApp } from "vue";
import { createI18n, I18nOptions } from 'vue-i18n';

const messages = {
    "1": {
        message: {
            oferta: "See Offer",
            descuento: "discount",
            personas: "{count} people",
            saliendo: "Flying from",
            from: "From",
            total: "Total",
            total_desde: "Total from",
            to: "To"
        },
        url: {
            paquetes: "packages/search"
        },
        lang: "en"
    },
    "2": {
        message: {
            oferta: "Ver Oferta",
            descuento: "de descuento",
            personas: "{count} persona | {count} personas",
            saliendo: "Saliendo de",
            from: "Desde",
            total: "Total",
            total_desde: "Total desde",
            to: "Hasta"
        },
        url: {
            paquetes: "paquetes/buscar"
        },
        lang: "es"
    },
    "5": {
        message: {
            oferta: "Ver Oferta",
            descuento: "de descuento",
            personas: "{count} persona | {count} personas",
            saliendo: "Saliendo de",
            from: "Desde",
            total: "Total",
            total_desde: "Total desde",
            to: "Hasta"
        },
        url: {
            paquetes: "paquetes/buscar"
        },
        lang: "es"
    },
};

let datetimeFormats: I18nOptions["datetimeFormats"] = {
    'en': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            month: 'long', day: 'numeric',
            weekday: 'long'
        }
    },
    'es': {
        short: {
            month: 'long', day: 'numeric',
            weekday: 'long'
        },
        long: {
            month: 'long', day: 'numeric',
            weekday: 'long'
        }
    }
}


const i18n = createI18n({
    legacy: false,
    messages,
    datetimeFormats,
});

const app = createApp(App).use(i18n).mount("#app");